(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-color-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-color-swatches')) {
    class CardColorSwatches extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const card = this.closest('.card-wrapper');
        if (!card) return;
        this.initialized = true;
        const cardImages = Array.from(card.querySelectorAll('.card__media .media img'));
        const cardImage = cardImages[0];
        const secondaryCardImage = cardImages[1];
        const cardMedia = card.querySelector('.card__media');
        const cardLinks = Array.from(card.querySelectorAll('[data-card-product-link]'));
        const buttons = Array.from(this.querySelectorAll('[data-card-color-swatch]'));
        const variantBadges = Array.from(card.querySelectorAll('[data-card-variant-badge]'));
        const priceMapElement = this.querySelector('[data-card-variant-prices]');
        let variantPriceKeys = {};
        if (priceMapElement) {
          try { variantPriceKeys = JSON.parse(priceMapElement.textContent); } catch { variantPriceKeys = {}; }
        }
        const priceTemplates = new Map(Array.from(this.querySelectorAll('template[data-card-price-key]'), template => [template.dataset.cardPriceKey, template]));
        let currentPriceKey = null;
        const updatePrice = (variantId) => {
          const priceKey = variantPriceKeys[String(variantId || '')];
          if (!priceKey || priceKey === currentPriceKey) return;
          const priceTemplate = priceTemplates.get(priceKey);
          const currentPrice = card.querySelector('.card-information > [data-card-price]');
          const replacement = priceTemplate?.content.firstElementChild;
          if (!currentPrice || !replacement) return;
          currentPrice.replaceChildren(...Array.from(replacement.childNodes, node => node.cloneNode(true)));
          currentPrice.className = replacement.className;
          currentPriceKey = priceKey;
        };

        if (cardMedia && cardImage) {
          card.classList.add('has-image-hover-zone');
          card.addEventListener('pointermove', (event) => {
            const mediaBounds = cardMedia.getBoundingClientRect();
            const isImageHovered =
              event.clientX >= mediaBounds.left &&
              event.clientX <= mediaBounds.right &&
              event.clientY >= mediaBounds.top &&
              event.clientY <= mediaBounds.bottom;
            card.classList.toggle('is-image-hovered', isImageHovered);
          });
          card.addEventListener('pointerleave', () => {
            card.classList.remove('is-image-hovered');
          });
        }

        const updateBadges = (button) => {
          const status = button.dataset.cardStatus || 'sold_out';
          variantBadges.forEach((badge) => {
            const badgeStatus = badge.dataset.variantBadgeStatus;
            const isSale = badgeStatus === 'sale' && button.dataset.cardOnSale === 'true';
            const shouldShow = badgeStatus === status || (status === 'available' && isSale);
            badge.classList.toggle('hidden', !shouldShow);
          });
        };

        const showImage = (button) => {
          const source = button.dataset.imageSrc;
          if (!source || !cardImage) return;
          cardImage.removeAttribute('srcset');
          cardImage.setAttribute('src', source);
          cardImage.setAttribute('alt', button.dataset.imageAlt || '');
          if (secondaryCardImage) {
            secondaryCardImage.removeAttribute('srcset');
            secondaryCardImage.setAttribute('src', button.dataset.secondaryImageSrc || source);
            secondaryCardImage.setAttribute('alt', button.dataset.secondaryImageAlt || button.dataset.imageAlt || '');
          }
        };

        const select = (button, updateImage = true) => {
          buttons.forEach((item) => {
            const isSelected = item === button;
            item.classList.toggle('is-active', isSelected);
            item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
          cardLinks.forEach((link) => {
            if (button.dataset.cardUrl) link.setAttribute('href', button.dataset.cardUrl);
          });
          card.classList.remove('is-image-hovered');
          if (updateImage) showImage(button);
          updateBadges(button);
          updatePrice(button.dataset.cardVariantId);
        };

        this.selectVariant = ({ id, color, chooseSize = true, status }) => {
          const normalizedColor = String(color || '').trim().toLocaleLowerCase();
          const button = buttons.find((item) =>
            (item.dataset.cardColorName || '').trim().toLocaleLowerCase() === normalizedColor
          );
          if (!button || !id) return false;
          select(button);
          const destination = new URL(button.dataset.cardUrl, window.location.origin);
          destination.searchParams.set('variant', id);
          if (chooseSize) destination.searchParams.set('sx_choose_size', '1');
          else destination.searchParams.delete('sx_choose_size');
          cardLinks.forEach((link) => link.setAttribute('href', destination.pathname + destination.search));
          if (status) updateBadges({ dataset: { cardStatus: status, cardOnSale: button.dataset.cardOnSale } });
          updatePrice(id);
          return true;
        };
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.getAttribute('aria-disabled') === 'true') return;
            const request = new CustomEvent('saxone:card-color-select', {
              bubbles: true,
              cancelable: true,
              detail: { color: button.dataset.cardColorName }
            });
            if (this.dispatchEvent(request)) select(button);
          });
        });
        const activeButton = this.querySelector('.is-active') || buttons[0];
        if (activeButton) select(activeButton, false);
      }
    }
    customElements.define('card-color-swatches', CardColorSwatches);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saxone-header-menu')) {
    customElements.define('saxone-header-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.toggle = this.querySelector('.saxone-header-menu__toggle');
        this.panel = this.querySelector('.saxone-header-menu__panel');
        this.parentLink = this.querySelector('.saxone-header-menu__link');
        if (!this.toggle || !this.panel || !this.parentLink) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.toggle.addEventListener('click', () => {
          this.panel.hidden ? this.open() : this.close();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch' || !this.hoverQuery.matches) return;
          const focusedMenu = document.activeElement?.closest('saxone-header-menu');
          if (focusedMenu && focusedMenu !== this && !focusedMenu.panel?.hidden) return;
          window.clearTimeout(this.closeTimer);
          this.open();
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch' || !this.hoverQuery.matches) return;
          this.closeTimer = window.setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 180);
        }, options);
        this.addEventListener('focusin', () => {
          window.clearTimeout(this.closeTimer);
        }, options);
        this.addEventListener('focusout', () => {
          window.clearTimeout(this.focusTimer);
          this.focusTimer = window.setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 0);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            if (event.target.closest('details[open]')) return;
            event.preventDefault();
            event.stopPropagation();
            this.close();
            this.toggle.focus();
          }
          if (event.key === 'ArrowDown' && (event.target === this.toggle || event.target === this.parentLink)) {
            event.preventDefault();
            this.open();
            this.panel.querySelector('a[href], summary, button')?.focus();
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.contains(event.target)) this.close();
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        window.clearTimeout(this.closeTimer);
        window.clearTimeout(this.focusTimer);
      }

      open() {
        window.clearTimeout(this.closeTimer);
        this.closest('nav')?.querySelectorAll('saxone-header-menu').forEach((menu) => {
          if (menu !== this && typeof menu.close === 'function') menu.close();
        });
        this.panel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
      }

      close() {
        window.clearTimeout(this.closeTimer);
        if (!this.panel || !this.toggle) return;
        this.panel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.panel.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saxone-collection-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saxone-collection-fit')) {
    class SaxoneCollectionFit extends HTMLElement {
      static selections = new Map();

      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.key = `${location.pathname}:${this.dataset.sectionId}`;
        this.layout = this.closest('.saxone-collection-layout');
        this.container = this.closest('#ProductGridContainer');
        this.grid = this.container?.querySelector('#product-grid');
        if (!this.grid) return;
        this.sizeSelect = this.querySelector('[data-fit-size]');
        this.colorSelect = this.querySelector('[data-fit-color]');
        this.resetButton = this.querySelector('[data-fit-reset]');
        this.count = this.querySelector('[data-fit-count]');
        this.empty = this.querySelector('[data-fit-empty]');
        try {
          this.products = JSON.parse(this.querySelector('[data-fit-products]').textContent);
          this.labels = JSON.parse(this.querySelector('[data-fit-labels]').textContent);
        } catch {
          return;
        }
        this.rows = new Map(Array.from(this.grid.querySelectorAll('[data-saxone-product-id]'), row => [row.dataset.saxoneProductId, row]));
        if (this.rows.size !== this.products.length || this.products.length !== Number(this.dataset.expectedCount)) return;
        this.nativeCounts = new Map(Array.from(document.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count'), count => [count, count.textContent]));
        const params = new URL(location.href).searchParams;
        const fromUrl = params.has('sx_size') || params.has('sx_color');
        this.state = fromUrl ? this.readUrl() : SaxoneCollectionFit.selections.get(this.key) || { size: '', color: '' };
        this.populate();
        this.sizeSelect.addEventListener('change', () => this.onChange());
        this.colorSelect.addEventListener('change', () => this.onChange());
        this.resetButton.addEventListener('click', () => {
          this.sizeSelect.value = '';
          this.colorSelect.value = '';
          this.onChange();
          this.sizeSelect.focus();
        });
        this.onSwatchSelect = (event) => this.selectSwatch(event);
        this.grid.addEventListener('saxone:card-color-select', this.onSwatchSelect);
        this.hidden = false;
        this.layout?.classList.add('saxone-fit-ready');
        this.apply(false);
      }

      disconnectedCallback() {
        this.layout?.classList.remove('saxone-fit-ready');
        this.grid?.removeEventListener('saxone:card-color-select', this.onSwatchSelect);
      }

      normalize(value) {
        return String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ');
      }

      sizeKey(value) {
        const normalized = this.normalize(value).replace(',', '.').replace(/\.0$/, '');
        const halfSize = normalized.match(/^(\d+)\s*\+$/);
        return halfSize ? `${halfSize[1]}.5` : normalized;
      }

      colorKey(value) {
        const name = this.normalize(value);
        const aliases = {
          nero: 'black', 'marrone scuro': 'dark brown', marrone: 'brown', bordeaux: 'burgundy',
          castagna: 'chestnut', 'rosso legno': 'redwood', 'blu navy': 'navy', 'blu marino': 'navy',
          verde: 'green', rosso: 'red', blu: 'blue', bianco: 'white', tabacco: 'tobacco'
        };
        return aliases[name] || name;
      }

      readUrl() {
        const params = new URL(location.href).searchParams;
        return { size: this.sizeKey(params.get('sx_size')), color: this.colorKey(params.get('sx_color')) };
      }

      populate() {
        const sizes = new Map();
        const colors = new Map();
        this.products.forEach(product => product.variants.forEach(variant => {
          if (variant[1]) sizes.set(this.sizeKey(variant[1]), variant[1]);
          if (variant[2]) colors.set(this.colorKey(variant[2]), this.labels.colors[this.colorKey(variant[2])] || variant[2]);
        }));
        if (this.state.size && !sizes.has(this.state.size)) sizes.set(this.state.size, this.state.size);
        if (this.state.color && !colors.has(this.state.color)) colors.set(this.state.color, this.labels.colors[this.state.color] || this.state.color);
        const addOptions = (select, values, selected) => {
          while (select.options.length > 1) select.remove(1);
          Array.from(values).sort((a, b) => String(a[1]).localeCompare(String(b[1]), document.documentElement.lang, { numeric: true })).forEach(([value, label]) => {
            select.add(new Option(label, value));
          });
          select.value = selected;
        };
        addOptions(this.sizeSelect, sizes, this.state.size);
        addOptions(this.colorSelect, colors, this.state.color);
      }

      onChange() {
        this.state = { size: this.sizeSelect.value, color: this.colorSelect.value };
        this.apply(true);
      }

      apply(push) {
        const { size, color } = this.state;
        const active = Boolean(size || color);
        const stockOnly = this.dataset.stockOnly === 'true';
        let count = 0;
        this.products.forEach(product => {
          const row = this.rows.get(product.id);
          const matches = product.variants.filter(variant => (!size || this.sizeKey(variant[1]) === size) && (!color || this.colorKey(variant[2]) === color));
          this.updateSwatches(row, matches, active || stockOnly);
          const match = matches.find(variant => variant[3]) || matches[0];
          const visible = (!active && !stockOnly) || Boolean(match);
          row.hidden = !visible;
          if (!visible) return;
          count += 1;
          if (active && match) this.selectVariant(row, match, Boolean(size));
          if (!active) this.restoreVariant(row);
        });
        const countText = (count === 1 ? this.labels.one : this.labels.other).replace('[count]', String(count));
        this.count.textContent = countText;
        this.resetButton.hidden = !active;
        this.empty.hidden = count !== 0 || this.products.length === 0;
        this.nativeCounts.forEach((original, element) => {
          element.textContent = active || stockOnly ? countText : original;
        });
        SaxoneCollectionFit.selections.set(this.key, { ...this.state });
        this.updateUrl(push);
      }

      updateSwatches(row, variants, constrained) {
        row.querySelectorAll('[data-card-color-swatch]').forEach(button => {
          if (!button.fitOriginalLabel) {
            button.fitOriginalLabel = {
              label: button.getAttribute('aria-label'),
              title: button.getAttribute('title')
            };
          }
          const blocked = constrained && !variants.some(variant => this.colorKey(variant[2]) === this.colorKey(button.dataset.cardColorName));
          const original = button.fitOriginalLabel;
          if (blocked) {
            button.setAttribute('aria-disabled', 'true');
            button.setAttribute('aria-label', `${original.label} — ${this.labels.color_unavailable}`);
            button.setAttribute('title', `${original.title} — ${this.labels.color_unavailable}`);
          } else {
            button.removeAttribute('aria-disabled');
            button.setAttribute('aria-label', original.label);
            button.setAttribute('title', original.title);
          }
        });
      }

      selectSwatch(event) {
        if (!this.state.size && !this.state.color && this.dataset.stockOnly !== 'true') return;
        const row = event.target.closest('[data-saxone-product-id]');
        const product = this.products.find(item => item.id === row?.dataset.saxoneProductId);
        if (!product) return;
        event.preventDefault();
        const requestedColor = this.colorKey(event.detail.color);
        if (this.state.color && requestedColor !== this.state.color) return;
        const matches = product.variants.filter(variant => this.colorKey(variant[2]) === requestedColor && (!this.state.size || this.sizeKey(variant[1]) === this.state.size));
        const match = matches.find(variant => variant[3]) || matches[0];
        if (match) this.selectVariant(row, match, Boolean(this.state.size));
      }

      selectVariant(row, variant, sizeChosen) {
        const swatches = row.querySelector('card-color-swatches');
        if (!row.fitOriginal) {
          const activeButton = swatches?.querySelector('[aria-pressed="true"]');
          const originalLink = row.querySelector('[data-card-product-link]');
          const originalUrl = originalLink ? new URL(originalLink.href, location.origin) : null;
          row.fitOriginal = {
            links: Array.from(row.querySelectorAll('[data-card-product-link]'), link => [link, link.getAttribute('href')]),
            color: activeButton?.dataset.cardColorName || '',
            id: originalUrl?.searchParams.get('variant') || '',
            chooseSize: originalUrl?.searchParams.get('sx_choose_size') === '1',
            status: activeButton?.dataset.cardStatus || ''
          };
        }
        if (swatches && typeof swatches.selectVariant === 'function') {
          swatches.selectVariant({ id: variant[0], color: variant[2], chooseSize: !sizeChosen, status: variant[4] });
        }
        row.querySelectorAll('[data-card-product-link]').forEach(link => {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('variant', variant[0]);
          if (sizeChosen) url.searchParams.delete('sx_choose_size');
          else url.searchParams.set('sx_choose_size', '1');
          link.href = `${url.pathname}${url.search}${url.hash}`;
        });
      }

      restoreVariant(row) {
        if (!row.fitOriginal) return;
        const swatches = row.querySelector('card-color-swatches');
        if (swatches && typeof swatches.selectVariant === 'function' && row.fitOriginal.color) {
          swatches.selectVariant(row.fitOriginal);
        }
        row.fitOriginal.links.forEach(([link, href]) => link.setAttribute('href', href));
        delete row.fitOriginal;
      }

      updateUrl(push) {
        const url = new URL(location.href);
        const oldUrl = url.href;
        for (const [param, value] of [['sx_size', this.state.size], ['sx_color', this.state.color]]) {
          if (value) url.searchParams.set(param, value);
          else url.searchParams.delete(param);
        }
        if (url.href === oldUrl) return;
        const historyState = { ...history.state, searchParams: url.searchParams.toString() };
        history[push ? 'pushState' : 'replaceState'](historyState, '', `${url.pathname}${url.search}${url.hash}`);
      }
    }

    customElements.define('saxone-collection-fit', SaxoneCollectionFit);
    window.addEventListener('popstate', () => {
      document.querySelectorAll('saxone-collection-fit').forEach(element => {
        if (!element.initialized || !element.products) return;
        element.state = element.readUrl();
        SaxoneCollectionFit.selections.set(element.key, { ...element.state });
        element.populate();
        element.apply(false);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saxone-product-size-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saxone-size-choice')) {
    customElements.define('saxone-size-choice', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        const size = this.sizeInput;
        if (!size) { this.hidden = true; return; }
        const params = new URLSearchParams(window.location.search);
        const resolvedVariantId = this.purchaseForm?.querySelector('[name="id"]')?.value;
        this.confirmedSize = params.get('variant') === resolvedVariantId && params.get('sx_choose_size') !== '1' ? size.value : null;
        this.onChange = this.handleChange.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onSubmit = this.handleSubmit.bind(this);
        this.productInfo.addEventListener('change', this.onChange, true);
        this.productInfo.addEventListener('click', this.onClick, true);
        this.productInfo.addEventListener('submit', this.onSubmit, true);
        this.observer = new MutationObserver(() => this.syncSizeInput());
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
        this.syncSizeInput();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.productInfo?.removeEventListener('change', this.onChange, true);
        this.productInfo?.removeEventListener('click', this.onClick, true);
        this.productInfo?.removeEventListener('submit', this.onSubmit, true);
      }

      get sizeInput() {
        return Array.from(this.productInfo?.querySelectorAll('select[data-saxone-size]') || [])
          .find((select) => select.closest('variant-selects')?.style.display !== 'none');
      }

      syncSizeInput() {
        const size = this.sizeInput;
        if (!size) return;
        const placeholder = size.querySelector('[data-saxone-size-placeholder]');
        if (this.confirmedSize && size.value === this.confirmedSize) {
          placeholder?.remove();
          size.removeAttribute('data-saxone-size-pending');
          this.querySelector('.saxone-size-choice__error').hidden = true;
          this.syncChoiceUrl();
          return;
        }
        if (this.confirmedSize && !placeholder) this.confirmedSize = null;
        if (!this.confirmedSize && !placeholder) {
          const selected = size.selectedOptions[0];
          if (!selected) return;
          const prompt = document.createElement('option');
          prompt.id = size.id + '-choose';
          prompt.value = '';
          prompt.textContent = this.dataset.prompt;
          prompt.disabled = true;
          prompt.dataset.saxoneSizePlaceholder = '';
          prompt.dataset.optionValueId = selected.dataset.optionValueId;
          if (selected.dataset.productUrl) prompt.dataset.productUrl = selected.dataset.productUrl;
          size.prepend(prompt);
          size.value = '';
          size.setAttribute('data-saxone-size-pending', '');
        }
        this.syncChoiceUrl();
      }

      syncChoiceUrl() {
        const url = new URL(window.location.href);
        const pending = !this.confirmedSize && url.searchParams.has('variant');
        if (pending && url.searchParams.get('sx_choose_size') !== '1') {
          url.searchParams.set('sx_choose_size', '1');
          window.history.replaceState(window.history.state, '', url);
        } else if (this.confirmedSize && url.searchParams.has('sx_choose_size')) {
          url.searchParams.delete('sx_choose_size');
          window.history.replaceState(window.history.state, '', url);
        }
      }

      handleChange(event) {
        if (!event.target.matches('select[data-saxone-size]') || !event.target.value) return;
        this.confirmedSize = event.target.value;
        this.querySelector('.saxone-size-choice__error').hidden = true;
        event.target.removeAttribute('data-saxone-size-pending');
      }

      get purchaseForm() {
        return document.getElementById(this.dataset.formId);
      }

      handleClick(event) {
        const button = event.target.closest('.product-form__buttons button, button[type="submit"], input[type="submit"]');
        if (button && (button.form === this.purchaseForm || button.closest('form') === this.purchaseForm)) this.guardPurchase(event);
      }

      handleSubmit(event) {
        if (event.target === this.purchaseForm) this.guardPurchase(event);
      }

      guardPurchase(event) {
        const size = this.sizeInput;
        if (!size || this.confirmedSize && size.value === this.confirmedSize) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('.saxone-size-choice__error').hidden = false;
        size.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saxone-restock-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saxone-restock-bar')) {
    customElements.define('saxone-restock-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
          button.querySelector('[data-pause-label]').textContent = paused ? button.dataset.resume : button.dataset.pause;
        });
        const update = () => {
          const expired = Date.now() >= Date.parse(this.dataset.end);
          this.querySelectorAll('[data-sale-text]').forEach(node => { node.hidden = expired; });
          this.querySelectorAll('[data-evergreen-text]').forEach(node => { node.hidden = !expired; });
          const text = this.querySelector(expired ? '[data-evergreen-text]' : '[data-sale-text]');
          this.querySelector('a').setAttribute('aria-label', text.textContent.trim());
        };
        update();
        const remaining = Date.parse(this.dataset.end) - Date.now();
        if (remaining > 0 && remaining < 2147483647) this.expiryTimer = setTimeout(update, remaining + 100);
      }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
